"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upload = upload;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
function upload(_ref) {
  var action = _ref.action,
    file = _ref.file,
    filename = _ref.filename,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    _ref$headers = _ref.headers,
    headers = _ref$headers === void 0 ? {} : _ref$headers,
    _ref$withCredentials = _ref.withCredentials,
    withCredentials = _ref$withCredentials === void 0 ? false : _ref$withCredentials,
    _ref$onProgress = _ref.onProgress,
    onProgress = _ref$onProgress === void 0 ? function () {
      return null;
    } : _ref$onProgress,
    _ref$onSuccess = _ref.onSuccess,
    onSuccess = _ref$onSuccess === void 0 ? function () {
      return null;
    } : _ref$onSuccess,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? function () {
      return null;
    } : _ref$onError;
  var formData = new FormData();
  var xhr = new XMLHttpRequest();
  xhr.onload = function (event) {
    if (!(xhr.status >= 200 && xhr.status < 300)) {
      var error = new Error("".concat(xhr.status, " ").concat(xhr.statusText));
      onError(error, {
        event: event,
        xhr: xhr,
        file: file
      });
      return;
    }
    var text = xhr.responseText || xhr.response;
    try {
      var _data = JSON.parse(text);
      onSuccess(_data, {
        event: event,
        xhr: xhr,
        file: file
      });
    } catch (err) {
      onSuccess(text, {
        event: event,
        xhr: xhr,
        file: file
      });
    }
  };
  xhr.onerror = function (event) {
    return onError(new Error('Http Request Error'), {
      event: event,
      xhr: xhr,
      file: file
    });
  };
  if (onProgress && xhr.upload) {
    xhr.upload.onprogress = function (event) {
      if (event.lengthComputable && event.total) {
        onProgress({
          total: event.total,
          loaded: event.loaded,
          percent: event.loaded / event.total * 100
        }, {
          event: event,
          xhr: xhr,
          file: file
        });
      }
    };
  }
  Object.keys(data).forEach(function (key) {
    formData.append(key, data[key]);
  });
  formData.append(filename, file);
  xhr.open('POST', action, true);
  xhr.withCredentials = withCredentials;
  Object.keys(headers).forEach(function (key) {
    xhr.setRequestHeader(key, headers[key]);
  });
  xhr.send(formData);
  return xhr;
}